export class AvailabilityReport {
  departureTimestamp: string;
  routeLine: string;
  freeSeats: number;
  takenSeats: number;
  percentTaken: number;

  constructor(data: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/AvailabilityReport.ts